import type {
	DrillDownRequest,
	DrillDownResponse,
	TransformedDrillDownResponse,
} from './types.tsx';

export const transformSource = (
	{ start, limit }: DrillDownRequest,
	response: DrillDownResponse,
): TransformedDrillDownResponse => {
	const page = start / limit + 1;

	return { ...response, page, pageSize: limit };
};
